import { AppLink } from "@/components/atoms/AppLink";
import { Empty } from "@/components/atoms/Empty";
import EmptyState from "@/components/atoms/Icon/emptyState";
import { Paragraph } from "@/components/atoms/Paragraph";
import type { IEmptyStateSearchResultProps } from "@/components/molecules/ApplicationsList/types";
import { useAuthUser } from "@/hooks/common/useAuthUser";
import { useTranslations } from "@/hooks/common/useTranslations";

const EmptyStateSearchResult = ({
  isSearchDropDown = true,
}: IEmptyStateSearchResultProps) => {
  const { t } = useTranslations("common");
  const { workspaceConfig } = useAuthUser();

  return (
    <Empty
      title={t("noSearchResult")}
      icon={isSearchDropDown ? <EmptyStateSearchResult /> : <EmptyState />}
      description={
        workspaceConfig?.isCore && (
          <Paragraph size="small" type="secondary">
            {t("wouldYouLikeToReq")}
            <AppLink
              href="https://community.ucraft.ai/integrations"
              target="_blank"
              className="text-primary-selected"
            >
              {t("clickToSubmitRequest")}
            </AppLink>
          </Paragraph>
        )
      }
    />
  );
};

export default EmptyStateSearchResult;
